const { useCallback, useRef, useState } = require('react');

const internals = {
    noop: () => {}
};

exports.useChatConfirmationDialog = function useChatConfirmationDialog() {

    const [dialog, setDialog] = useState({
        confirmLabel: 'Yes',
        content: '',
        declineLabel: 'No',
        hideDecline: false,
        isOpen: false,
        title: ''
    });
    const confirmRef = useRef(internals.noop);

    const closeDialog = useCallback(() => {

        setDialog((current) => ({ ...current, isOpen: false }));
    }, []);

    const openDialog = useCallback((props) => {

        const {
            confirm,
            confirmLabel,
            declineLabel,
            hideDecline,
            message,
            title
        } = props;

        confirmRef.current = confirm || internals.noop;
        setDialog({
            confirmLabel: confirmLabel || 'Yes',
            content: message,
            declineLabel: declineLabel || 'No',
            hideDecline: !!hideDecline,
            isOpen: true,
            title: title || ''
        });
    }, []);

    const confirmDialog = useCallback(() => {

        closeDialog();
        confirmRef.current();
    }, [closeDialog]);

    const updateAlertFunction = useCallback((confirm, message, title) => {

        openDialog({
            confirm,
            message,
            title
        });
    }, [openDialog]);

    return {
        closeDialog,
        confirmDialog,
        dialog,
        openDialog,
        updateAlertFunction
    };
};
